import { filter, some, cloneDeep, first, orderBy } from 'lodash';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { NgForm } from '@angular/forms';
import { Component, ViewEncapsulation, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import SelfPay from 'src/app/models/selfPay';
import Plan from 'src/app/models/plan';
import { env } from 'src/env/development';
import Agency from 'src/app/models/agency';
import * as dayjs from 'dayjs';
import SelfPayFormDependent from 'src/app/models/selfPayFormDependent';
import { CoreService } from 'src/app/services/core.service';
import Subscriber from 'src/app/models/subscriber';
import { Lookups, LookupType } from 'src/app/decorators/lookups.decorator';
import PlanType from 'src/app/models/planType';
import { ActivatedRoute } from '@angular/router';

@Lookups(LookupType.PlanType)
@Component({
  selector: 'self-pay-elect-vision',
  templateUrl: 'selfPay.electVision.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class SelfPayElectVisionComponent implements OnInit {
  @Output() saveSelfPay: EventEmitter<SelfPay> = new EventEmitter<SelfPay>();
  @Output() previous: EventEmitter<void> = new EventEmitter();
  @ViewChild('electVisionForm') public electVisionForm: NgForm;
  @Input() selfPay: SelfPay;
  @Input() availablePlans: Plan[];
  @Input() agency: Agency;
  @Input() subscriber: Subscriber;
  visionPlans: Plan[];
  sebbVisionPlans: Plan[];
  env = env;
  noVisionSelectionMade = false;
  coverageYear: number;
  selectedPlanId: string;
  lookups = { planTypes: [] };
  planLinks =
    {
      'T1': { display: (sp: SelfPay) => true, link: 'https://davisvision.com/' },
      'T2': { display: (sp: SelfPay) => true, link: 'https://member.eyemedvisioncare.com/' },
      'T3': { display: (sp: SelfPay) => true, link: 'https://www.metlife.com/' },

      'T1P': { display: (sp: SelfPay) => true, link: 'https://www.metlife.com/info/wshca/benefits/davis-vision/' },
      'T2P': { display: (sp: SelfPay) => true, link: 'https://member.eyemedvisioncare.com/wahca' },
      'T3P': { display: (sp: SelfPay) => true, link: 'https://www.metlife.com/info/wshca/benefits/vision-insurance/' },
    };

  constructor(private route: ActivatedRoute,
    private coreService: CoreService) {}

  ngOnInit() {
    this.lookups.planTypes = this.route.snapshot.data.lookups.planTypes;
    this.noVisionSelectionMade = !this.selfPay?.formJson?.subscriber?.visionEnrollInd && !some(this.selfPay?.formJson?.dependents, (d: SelfPayFormDependent) => d.visionCoverInd);

    this.coverageYear = 2025;//dayjs(this.selfPay.coverageEffectiveDate ?? new Date()).year();

    // Filter based on PEBB/SEBB
    this.visionPlans = filter(this.availablePlans, (ap) => ap.planType?.planTypeCode === env.visionPlanTypeCode && !ap.planName.includes('Default') && ap.agencyId === this.selfPay.agency.agencyId);
    this.visionPlans = cloneDeep(this.visionPlans);

    if (this.selfPay.formJson.visionPlan && Object.keys(this.selfPay.formJson.visionPlan).length > 0) {
      this.selectedPlanId = this.selfPay.formJson.visionPlan.planId;
    } else if (this.selfPay.isPEBB && this.selfPay.isCobraSOE) {
      var enrollments = this.subscriber.enrollments.filter(e =>
        e.plan.planType.planTypeCode === env.visionPlanTypeCode &&
        e.isActive(this.selfPay.coverageEffectiveDate ?? new Date())
      );
      
      if (enrollments.length)
        this.selectedPlanId = enrollments[0].planId;
    }
  }

  setPlan(plan) {
    this.selfPay.formJson.visionPlan = plan;
    this.selfPay.formJson.continueCurrentSelectedVision = false;
  }

  emitSelfPay(e) {
    this.saveSelfPay.emit(e);
  }
  
  continueCurrentSelected(checked) {
    if(checked) {
      this.selfPay.formJson.visionPlan = null;
      this.selectedPlanId = null;
    }
  }

  continueToNextStep() {
    if (!this.selfPay.formJson.visionPlan || (this.selectedPlanId && this.selfPay.formJson.visionPlan.planId != this.selectedPlanId))
      this.selfPay.formJson.visionPlan = this.visionPlans.filter(p => p.planId === this.selectedPlanId)[0];

    if (!(this.noVisionSelectionMade && !this.selfPay.isLWOP && !this.selfPay.isSebbCOBRA)) {
      // The above check is from the template when we show no elections made messaging; if that is up, let them continue
      
      if (this.selfPay.isRetiree || this.selfPay.isPebbCobraOE) {
        if (!this.selfPay?.formJson?.continueCurrentSelectedVision && !this.selfPay.formJson.visionPlan.planId) {
          this.coreService.popMessage('A single plan must be selected', 'error', 5000);
          return;
        }
      }
    }

    if (this.selfPay?.formJson?.continueCurrentSelectedVision) {
      const visionPlanTypeId = first(this.lookups.planTypes.filter((pt: PlanType) => pt.planTypeCode === env.visionPlanTypeCode)).planTypeId;
      this.selfPay.formJson.visionPlan = first(orderBy(this.subscriber.enrollments.filter(e => e.planTypeId === visionPlanTypeId), 'effectiveStartDate', 'desc'))?.plan;
    }

    this.saveSelfPay.emit(this.selfPay);
  }
}

